export default __webpack_public_path__ + "static/media/Neru_Bunny_Girl.c17100c3.png";